import { colorsPalettes } from "@similarweb/styles";

import { FIRST_WEEK_THEME } from "app/components/discountCampaign/CampaignPromoModal/themePresets";
import type { ICampaignScenarioConfig } from "app/components/discountCampaign/campaignScenarioConfig.types";

export const FIRST_WEEK_MONTHLY_CAMPAIGN_CTA = "firstweek";
export const FIRST_WEEK_PROMO_CODE = "Annual20";

const FIRST_WEEK_BANNER_GRADIENT = `linear-gradient(56deg, ${colorsPalettes.blue[500]} 20.04%, ${colorsPalettes.midnight[400]} 71.95%, ${colorsPalettes.midnight[500]} 100.02%)`;

const CAMPAIGN_DISCOUNT_PERCENTAGE = 20;

export const FIRST_WEEK_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL = new Set<string>([FIRST_WEEK_PROMO_CODE]);

export const FIRST_WEEK_CAMPAIGN_CONFIG: Omit<ICampaignScenarioConfig, "discountConfig"> = {
    banner: {
        theme: {
            color: colorsPalettes.carbon[0],
            background: FIRST_WEEK_BANNER_GRADIENT,
            counterColor: colorsPalettes.blue[500],
            ctaButtonColor: colorsPalettes.blue[500],
            showButton: true,
            showTimer: true,
            showCloseButton: true,
        },
        content: {
            text: "discount.first_week.banner.text",
            couponCode: FIRST_WEEK_PROMO_CODE,
            percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
        },
    },
    modal: {
        theme: FIRST_WEEK_THEME,
        content: {
            title: "modal.first_week.title.v2",
            buttonText: "discount.first_week.banner.button",
            percentageTranslationKey: "upgrade.to.annual.off",
            percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
            imageSrc: "gift_with_confetti.svg",
            discountCode: FIRST_WEEK_PROMO_CODE,
        },
    },
};
